import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubdivideIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4 4h16v16H4zM12 4v16m-8-8h16" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 4,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 20,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4,
			cy: 12,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 12,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgSubdivideIcon;
